import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { IntlMessage } from 'app/components/Intl';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

import FileUploadArea, { FileType } from '../../../../components/FileUploadArea';
import { downloadOcrCsvTemplate } from '../../Services/ConnectionService';

const OcrCsvUploadDialog = props => {
  const { open, setOpen, onConfirm, connectionId } = props;
  const [hasFiles, setHasFiles] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(undefined);
  const [downloading, setDownloading] = useState(false);

  const handleDownloadTemplate = async () => {
    setDownloading(true);
    try {
      const response = await downloadOcrCsvTemplate(connectionId);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const fileName = response.headers['x-filename'] || 'ocr-csv-template.csv';
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error downloading OCR CSV template:', error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={() => setOpen(false)} aria-labelledby="confirm-dialog">
      <DialogTitle id="ocr-csv-upload-dialog">
        <FormattedMessage id="upload.ocrCsv.title" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText marginBottom={theme => theme.spacing(1)}>
          <FormattedMessage id="upload.ocrCsv.helpMessage" />
        </DialogContentText>
        <Box marginBottom={2} textAlign={'center'} py={1}>
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={handleDownloadTemplate}
            disabled={downloading}
          >
            <FormattedMessage
              id={downloading ? 'upload.ocrCsv.downloadingTemplate' : 'upload.ocrCsv.downloadTemplate'}
            />
          </Button>
        </Box>
        <FileUploadArea
          types={[FileType.Csv]}
          disabled={false}
          showSuccessMessage={false}
          onChange={files => {
            setHasFiles(files.length > 0);
            setUploadedFiles(files);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => setOpen(false)}>
          <IntlMessage value={'no'} />
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm(uploadedFiles);
          }}
          disabled={!hasFiles}
        >
          <FormattedMessage id={'button.start'} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

OcrCsvUploadDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  onConfirm: PropTypes.func,
  connectionId: PropTypes.string,
};

export default OcrCsvUploadDialog;
